import http from '@/utils/http';
export class UserInfoApi {
    // 获取当前用户信息
    static async getCurrentUserInfo() {
        try {
            const response = await http.get('/test/user-info');
            // http.ts interceptor may unwrap payload to either the inner data or the whole wrapper
            // Normalize to always return the inner user object if present
            const possibleData = response?.data ?? response;
            if (possibleData && typeof possibleData === 'object' && 'email' in possibleData) {
                return possibleData;
            }
            if (possibleData && possibleData.data && typeof possibleData.data === 'object') {
                return possibleData.data;
            }
            // Fallback: return as any
            return possibleData;
        }
        catch (error) {
            console.error('获取用户信息失败:', error);
            throw error;
        }
    }
    // 获取用户列表
    static async getUserList() {
        try {
            const response = await http.get('/test/user-list');
            const possibleData = response?.data ?? response;
            if (Array.isArray(possibleData)) {
                return possibleData;
            }
            if (possibleData?.data && Array.isArray(possibleData.data)) {
                return possibleData.data;
            }
            return [];
        }
        catch (error) {
            console.error('获取用户列表失败:', error);
            throw error;
        }
    }
}
export default UserInfoApi;
